import { useQuery } from "app/tools/query/hooks/useQuery";
import { useAuthTokenContext } from "User/Authentication/context";

import { User } from "../../entity";
import { readUser } from "./endpoint";

export const useUserQuery = () => {
  const authContext = useAuthTokenContext();

  return useQuery<User>("Data uživatele", {
    enabled: !!authContext?.token,
    queryFn: readUser,
    queryKey: ["user", { token: authContext?.token }],
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    retry: 2,
  });
};
